import { renderToStaticMarkup } from 'react-dom/server';
import React from 'react';
import { ChartTooltip, ChartTooltipProps } from './index';

/**
 * This method is used to render a chart tooltip to a string. This is used in
 * highcharts because its api only supports passing in a string for the tooltip.
 * NOTE: The tooltip will not be interactive when rendered this way.
 * @param props
 * @returns
 */
export function renderChartTooltipToString(props: ChartTooltipProps) {
  return renderToStaticMarkup(<ChartTooltip {...props} />);
}